<template>
  <div class="home-dynamic-search-body">
    <div class="home-dynamic-search-head">
      <span>关于「{{ search }}」的搜索结果，共 {{ newsList.length }} 条</span>
      <a-input-search
        style="width: 400px"
        placeholder="请输入关键词搜索"
        enter-button
        v-model="search"
        @search="onSearch"
      />
    </div>
    <div class="home-dynamic-search-content">
      <div
        class="home-dynamic-search-list"
        v-for="item in newsList"
        :key="item.id"
        @click="newsDetail(item.id)"
      >
        <div>
          <div>
            <p>{{ item.newsName }}</p>
            <span>{{ item.publishTime }}</span>
          </div>
          <p v-html="item.content"></p>
        </div>
        <!-- <span>/forum/topic/show/989298</span> -->
      </div>
    </div>
  </div>
</template>

<script>
import { getNewsList } from "@/api/news";
export default {
  data() {
    return {
      search: "",
      page: {
        size: 15,
        current: 1,
      },
      newsList: [],
    };
  },
  mounted() {
    this.search = this.$route.params.search;
    this.loadGetNewsList();
  },
  methods: {
    loadGetNewsList() {
      let data = {
        type: "",
        keywords: this.search,
      };
      getNewsList(this.page, data).then((res) => {
        this.newsList = res.data.records;
      });
    },
    onSearch() {
      if (!this.search) {
        this.$message.warning("请输入搜索内容");
        return;
      }
      this.loadGetNewsList();
    },
    newsDetail(id) {
      this.$router.push({
        path: "/homeDynamic/detail",
        query: { id: id },
      });
    },
  },
};
</script>

<style lang="less" scoped>
.home-dynamic-search-body {
  width: 1200px;
  margin: 0 auto;
  padding: 24px 0;
  .home-dynamic-search-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    > span {
      color: #8c8c8c;
    }
  }
  .home-dynamic-search-content {
    margin-top: 24px;
    background-color: #fff;
    padding: 0 24px;
    .home-dynamic-search-list {
      padding: 24px 0;
      border-bottom: 1px solid #f0f0f0;
      display: flex;
      justify-content: space-between;
      cursor: pointer;
      > div {
        // max-width: 70%;
        width: 100%;
        > div {
          display: flex;
          align-items: flex-end;
          justify-content: space-between;
          width: 100%;
          > p {
            font-size: 16px;
            margin-right: 24px;
            line-height: 16px;
            font-weight: bold;
          }
          > span {
            font-size: 14px;
            color: #bfbfbf;
            line-height: 14px;
          }
        }
        > p {
          color: #8c8c8c;
          line-height: 22px;
          margin-top: 20px;
          max-height: 44px;
          overflow: hidden;
        }
      }
      > span {
        color: #1abc9c;
        cursor: pointer;
      }
    }
  }
}
</style>
<style>
.before-content-body {
  background: #f7f7f7;
}
.ant-btn-primary {
  background-color: #1abc9c !important;
  border-color: #1abc9c !important;
}
</style>
